// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1fHkQ","label":"Completed_label__2Fysf"};